import { render, staticRenderFns } from "./shopuserdetail.vue?vue&type=template&id=72eaf842&scoped=true"
import script from "./shopuserdetail.vue?vue&type=script&lang=js"
export * from "./shopuserdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eaf842",
  null
  
)

export default component.exports